import React from 'react'
import { Grid, Paper } from '@mui/material'
import SettingNav from './SettingNav'
import BackToLeaseList from './BackToLeaseList'

const SettingPageLayout = ({ actionBar, children }) => {
  return (
    <Paper className="setting_details_section lease-details-section" elevation={0} sx={{ boxShadow: "0px 0px 2px 1px #BBBBBB" }}>
      <SettingNav />
      <div className='lease-details-content'>
        <Paper square className="responsive-paper">
          <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
            <Grid item size={{ md: 4, xs: 12 }} className="menu-container" {...(!actionBar ? { marginTop: '14px' } : {})}>
              <BackToLeaseList/>
            </Grid>
            {actionBar ? (
              <Grid item size={{ md: 8, xs: 12 }}>
                {actionBar}
              </Grid>
            ) : null}
          </Grid>
        </Paper>
        {children}
      </div>
    </Paper>
  )
}

export default SettingPageLayout
